// General UPI intent
export const ANDROID_UPI_INTENT_LINK = "upi://{deeplink}";
